import { render, staticRenderFns } from "./OutrightsSingleResults.vue?vue&type=template&id=48a11c2d"
import script from "./OutrightsSingleResults.vue?vue&type=script&lang=js"
export * from "./OutrightsSingleResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports